/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import { BulletList } from 'react-content-loader'

import '../ShopList/list.scss'

import { useNavigate } from 'react-router-dom'

import { ToRial } from '../../services/toRial'

export default function index(data, shop) {
  const [resturants, setResturants] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    console.log(data)
    setResturants(data.data)
  }, [data])

  return (
    <>
      <table className='table'>
        <thead>
          <tr>
            <th>عنوان</th>
            <th>قیمت</th>
            <th>قیمت با تخفیف</th>
            <th>ترتیب</th>
            <th>عملیات</th>
          </tr>
        </thead>
        <tbody>
          {resturants ? resturants.map(item => 
              item.shop[0] == data.shop || data.shop == undefined ?
              (<tr key={item._id}>
                <td>{item.name}</td>
                <td>{ToRial(item.price) + ' تومان '}</td>
                <td>{ToRial(item.discountPrice) + ' تومان '}</td>
                <td>{item.level}</td>
                <td>
                  <button onClick={() => navigate(`/foods/edit/${item._id}`)}>ویرایش</button>
                </td>
              </tr>) : '') : <tr><td colSpan="5"><BulletList rtl style={{ width: '30%', rowspan: '5' }}/></td></tr>}
        </tbody>
      </table>
    </>
  );
}
